module.exports = __webpack_public_path__ + "img/proctoring-testcase-infoIcon.304f2aae.svg";